export default "__VITE_ASSET__5Rrq$T$A__"